import React from "react";

// 쿠키 / 사이트 데이터(localStorage 포함)가 차단되어 로그인이 불가능한 환경에서
// 흰 화면(크래시) 대신, 사용자가 직접 설정을 변경할 수 있도록 안내하는 전체 화면 컴포넌트.
//
// 원인: Windows Edge "사이트에서 쿠키 데이터를 저장하고 읽도록 허용" OFF, 그룹정책,
//       쿠키 전체 차단 등. 클라이언트 설정이라 서버에서 강제할 수 없어 안내로만 해결한다.

const detectBrowserGuide = () => {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";

  if (/Edg\//i.test(ua)) {
    return {
      name: "Microsoft Edge",
      settingsUrl: "edge://settings/privacy/cookies",
      toggleLabel: "사이트에서 쿠키 데이터를 저장하고 읽도록 허용",
    };
  }

  if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) {
    return {
      name: "Google Chrome",
      settingsUrl: "chrome://settings/cookies",
      toggleLabel: "모든 쿠키 허용",
    };
  }

  return null;
};

export default () => {
  const guide = detectBrowserGuide();

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <h1 style={styles.title}>브라우저 설정 확인이 필요합니다</h1>

        <p style={styles.desc}>
          현재 브라우저에서 <b>쿠키 / 사이트 데이터 저장</b>이 차단되어 있어
          로그인할 수 없습니다.
          <br />
          아래 안내에 따라 설정을 변경한 뒤 <b>다시 시도</b>를 눌러 주세요.
        </p>

        <div style={styles.guideBox}>
          {guide ? (
            <>
              <p style={styles.guideTitle}>{guide.name}</p>
              <ol style={styles.ol}>
                <li>
                  주소창에{" "}
                  <code style={styles.code}>{guide.settingsUrl}</code> 를 입력하고
                  이동합니다.
                </li>
                <li>
                  <b>"{guide.toggleLabel}"</b> 항목을 <b>켜기(ON)</b>로 변경합니다.
                </li>
                <li>이 페이지로 돌아와 아래 "다시 시도"를 누릅니다.</li>
              </ol>
            </>
          ) : (
            <>
              <p style={styles.guideTitle}>설정 방법</p>
              <ol style={styles.ol}>
                <li>브라우저 설정 → 개인정보 / 쿠키 메뉴로 이동합니다.</li>
                <li>
                  <b>쿠키 및 사이트 데이터 저장 허용</b> 옵션을 켭니다.
                </li>
                <li>이 페이지로 돌아와 아래 "다시 시도"를 누릅니다.</li>
              </ol>
            </>
          )}
          <p style={styles.note}>
            ※ 회사·병원 등 관리되는 PC에서는 보안 정책으로 잠겨 있어 변경이 어려울 수
            있습니다. 이 경우 IT 담당자에게 문의하거나 개인 PC / 다른 브라우저(Chrome
            등)로 접속해 주세요.
          </p>
        </div>

        <button
          type="button"
          style={styles.btn}
          onClick={() => window.location.reload()}
        >
          다시 시도
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrap: {
    position: "fixed",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px",
    background: "#f4f5f7",
    fontFamily:
      "'Noto Sans KR', 'Apple SD Gothic Neo', -apple-system, sans-serif",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  card: {
    width: "100%",
    maxWidth: "480px",
    background: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
    padding: "40px 28px",
    textAlign: "center",
    boxSizing: "border-box",
  },
  icon: {
    fontSize: "44px",
    lineHeight: 1,
    marginBottom: "16px",
  },
  title: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#1f2937",
    margin: "0 0 12px",
  },
  desc: {
    fontSize: "14px",
    lineHeight: 1.6,
    color: "#4b5563",
    margin: "0 0 24px",
  },
  guideBox: {
    textAlign: "left",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "18px 20px",
    marginBottom: "24px",
  },
  guideTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#5959EF",
    margin: "0 0 10px",
  },
  ol: {
    margin: 0,
    paddingLeft: "20px",
    fontSize: "13px",
    lineHeight: 1.8,
    color: "#374151",
  },
  code: {
    background: "#eef2ff",
    color: "#4338ca",
    padding: "2px 6px",
    borderRadius: "4px",
    fontSize: "12px",
    wordBreak: "break-all",
  },
  note: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#9ca3af",
    margin: "14px 0 0",
  },
  btn: {
    width: "100%",
    height: "48px",
    border: "none",
    borderRadius: "10px",
    background: "#5959EF",
    color: "#ffffff",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
  },
  en: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#9ca3af",
    margin: "20px 0 0",
  },
};
